import React, { FC, useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { object } from 'yup';
import { DownloadReportFormCont, FormCell } from './DownloadReportForm.styles';
import { ISingleFlag } from '../../../constans/flags';
import { useAddTeam } from '../../../hooks/useAddTeam';
import { useLangManagement } from '../../../hooks/useLangManagement';
import { Label } from '../../AddParticipantModal/AddParticipantForm/AddParticipantForm.styles';
import SearchDropdown from '../../SearchDropdown/SearchDropdown';

const downloadFormSchema = object({
  preferredLanguage: object().nullable(),
});

interface IDownloadFormFullData {
  preferredLanguage: ISingleFlag;
  dataFormat: { id: string; name: string; shortName: string };
}

export interface IDownloadFormObj {
  preferredLanguage: string;
  dataFormat: string;
}

interface IDownloadReportForm {
  submit: (data: IDownloadFormObj) => void;
}
const DownloadReportForm: FC<IDownloadReportForm> = ({ submit }) => {
  const { lang } = useLangManagement();

  const { t } = useTranslation();
  const dataFormatOptions = [
    {
      id: 'a1',
      name: t('viewSurvey.reportsSetup.downloadModal.numbers'),
      shortName: 'numbers',
    },
    {
      id: 'a2',
      name: t('viewSurvey.reportsSetup.downloadModal.percentages'),
      shortName: 'percent',
    },
  ];
  const { alternativeLangArrWithIcons, getCurrentAlternativeLangObj } = useAddTeam();

  const defaultValues = {
    preferredLanguage: getCurrentAlternativeLangObj(lang),
    dataFormat: dataFormatOptions[0],
  };

  const { control, handleSubmit, reset } = useForm({
    defaultValues,
    resolver: yupResolver(downloadFormSchema),
  });

  useEffect(() => {
    const newDefaults = {
      preferredLanguage: getCurrentAlternativeLangObj(lang),
      dataFormat: dataFormatOptions[0],
    };
    reset(newDefaults);
  }, [lang, getCurrentAlternativeLangObj, reset]);

  const submitForm = (data: IDownloadFormFullData) => {
    const transformedForm = {
      preferredLanguage: data?.preferredLanguage?.shortName || 'en',
      dataFormat: data?.dataFormat?.shortName,
    };
    return submit(transformedForm);
  };

  return (
    <DownloadReportFormCont onSubmit={handleSubmit(submitForm)}>
      <FormCell>
        <Label>{t('viewSurvey.reportsSetup.downloadModal.language')}</Label>
        <Controller
          control={control}
          render={({ field: { onChange, value } }) => (
            <SearchDropdown
              items={alternativeLangArrWithIcons}
              placeholder={'viewSurvey.reportsSetup.downloadModal.language'}
              selectEl={onChange}
              width="320px"
              activeEl={value}
              selectFullObject
            />
          )}
          name="preferredLanguage"
        />
      </FormCell>
      {/* Data format removal, numbers or percentage */}
      {/* <FormCell>
        <Label>{t('viewSurvey.reportsSetup.downloadModal.showIn')}</Label>
        <Controller
          control={control}
          render={({ field: { onChange, value } }) => (
            <SearchDropdown
              items={dataFormatOptions}
              placeholder="Number"
              activeEl={value?.name || 'Numbers'}
              selectEl={onChange}
              width="320px"
              selectFullObject
            />
          )}
          name="dataFormat"
        />
      </FormCell> */}
      <button data-testid="downloadReportC2A" id="downloadReportC2A" type="submit" hidden>
        callToAction
      </button>
    </DownloadReportFormCont>
  );
};

export default DownloadReportForm;
